/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck bender-url isn't supported in TypeScript yet

import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { NavItemEnum } from '../routing/NavItems';
import BREEZE_INTELLIGENCE_ICON from 'bender-url!pricing-pages-lib/images/productIcons/BreezeIntelligence.svg';
import MARKETING_HUB_ICON from 'bender-url!../../img/productIcons/MarketingHub.svg';
import MARKETING_HUB_ENT_ICON from 'bender-url!../../img/productIcons/MarketingHub_Ent.svg';
import MARKETING_HUB_PRO_ICON from 'bender-url!../../img/productIcons/MarketingHub_Pro.svg';
import MARKETING_HUB_STARTER_ICON from 'bender-url!../../img/productIcons/MarketingHub_Starter.svg';
import SALES_HUB_ICON from 'bender-url!../../img/productIcons/SalesHub.svg';
import SALES_HUB_ENT_ICON from 'bender-url!../../img/productIcons/SalesHub_Ent.svg';
import SALES_HUB_PRO_ICON from 'bender-url!../../img/productIcons/SalesHub_Pro.svg';
import SALES_HUB_STARTER_ICON from 'bender-url!../../img/productIcons/SalesHub_Starter.svg';
import SERVICE_HUB_ICON from 'bender-url!../../img/productIcons/ServiceHub.svg';
import SERVICE_HUB_ENT_ICON from 'bender-url!../../img/productIcons/ServiceHub_Ent.svg';
import SERVICE_HUB_PRO_ICON from 'bender-url!../../img/productIcons/ServiceHub_Pro.svg';
import SERVICE_HUB_STARTER_ICON from 'bender-url!../../img/productIcons/ServiceHub_Starter.svg';
import CONTENT_HUB_ICON from 'bender-url!../../img/productIcons/ContentHub.svg';
import CONTENT_HUB_ENT_ICON from 'bender-url!../../img/productIcons/ContentHub_Ent.svg';
import CONTENT_HUB_PRO_ICON from 'bender-url!../../img/productIcons/ContentHub_Pro.svg';
import CONTENT_HUB_STARTER_ICON from 'bender-url!../../img/productIcons/ContentHub_Starter.svg';
import OPERATIONS_HUB_ICON from 'bender-url!../../img/productIcons/OperationsHub.svg';
import OPERATIONS_HUB_ENT_ICON from 'bender-url!../../img/productIcons/OperationsHub_Ent.svg';
import OPERATIONS_HUB_PRO_ICON from 'bender-url!../../img/productIcons/OperationsHub_Pro.svg';
import OPERATIONS_HUB_STARTER_ICON from 'bender-url!../../img/productIcons/OperationsHub_Starter.svg';
import COMMERCE_HUB_ICON from 'bender-url!../../img/productIcons/CommerceHub.svg';
import SMART_CRM_ICON from 'bender-url!../../img/productIcons/SmartCrm.svg';
import SMART_CRM_ENT_ICON from 'bender-url!../../img/productIcons/SmartCrm_Ent.svg';
import SMART_CRM_PRO_ICON from 'bender-url!../../img/productIcons/SmartCrm_Pro.svg';
export const ProductIconMap = {
  [MARKETING]: MARKETING_HUB_ICON,
  [SALES]: SALES_HUB_ICON,
  [SERVICE]: SERVICE_HUB_ICON,
  [CMS]: CONTENT_HUB_ICON,
  [OPERATIONS]: OPERATIONS_HUB_ICON,
  [COMMERCE]: COMMERCE_HUB_ICON,
  [NavItemEnum.BREEZE_INTELLIGENCE]: BREEZE_INTELLIGENCE_ICON,
  [NavItemEnum.SMART_CRM]: SMART_CRM_ICON
};
export const ProductTierIconMap = {
  [MARKETING]: {
    [STARTER]: MARKETING_HUB_STARTER_ICON,
    [PROFESSIONAL]: MARKETING_HUB_PRO_ICON,
    [ENTERPRISE]: MARKETING_HUB_ENT_ICON
  },
  [SALES]: {
    [STARTER]: SALES_HUB_STARTER_ICON,
    [PROFESSIONAL]: SALES_HUB_PRO_ICON,
    [ENTERPRISE]: SALES_HUB_ENT_ICON
  },
  [SERVICE]: {
    [STARTER]: SERVICE_HUB_STARTER_ICON,
    [PROFESSIONAL]: SERVICE_HUB_PRO_ICON,
    [ENTERPRISE]: SERVICE_HUB_ENT_ICON
  },
  [CMS]: {
    [STARTER]: CONTENT_HUB_STARTER_ICON,
    [PROFESSIONAL]: CONTENT_HUB_PRO_ICON,
    [ENTERPRISE]: CONTENT_HUB_ENT_ICON
  },
  [OPERATIONS]: {
    [STARTER]: OPERATIONS_HUB_STARTER_ICON,
    [PROFESSIONAL]: OPERATIONS_HUB_PRO_ICON,
    [ENTERPRISE]: OPERATIONS_HUB_ENT_ICON
  },
  [NavItemEnum.SMART_CRM]: {
    [PROFESSIONAL]: SMART_CRM_PRO_ICON,
    [ENTERPRISE]: SMART_CRM_ENT_ICON
  }
};